export function LocalizationHelper<Keys extends string>(name: string) {
  return (localization: Record<Keys, string | object>) => {
    return { [name]: localization };
  };
}
